import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import CustomStepper from '../../../EnvioStatusDetail/components/CustomStepper';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ENVIOS_API } from '../../../../../shared/services/envios';

export default function EnvioEstadoModal({ lastStatus, envio }) {
    const [step, setStep] = useState(1);
    const [statesList, setStatesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const steps = {
            //en preparación
            1: 1,
            2: 1,
            3: 1,
            //enviado
            4: 2,
            5: 2,
            //de camino
            6: 3,
            //entregado
            7: 4,
            //
            8: 0,
            9: 0,
        };
        setStep(steps[lastStatus]);
    }, []);

    const getStatesList = async () => {
        let list;
        if (lastStatus === 8) {
            list = [{ nombre: 'CANCELADO', codigo: '-1' }];
        } else if (envio.transportista_id === 1) {
            list = [
                {
                    nombre: 'DESCONOCIDO',
                    codigo: 'DESCONOCIDO',
                },
            ];
        } else {
            list = await getHermesStates();
        }
        setStatesList(list);
    };

    const getHermesStates = async () => {
        try {
            setIsLoading(true);
            const res = await ENVIOS_API.getShippingStates({
                codigo_transporte: envio.codigo_transporte,
                proveedor_id: envio.remitente.proveedor_id,
            });
            if (res?.success) {
                return res.data;
            }
            return [];
        } catch (e) {
            toast.error(
                'No se ha podido obtener la lista de estados de Hermes.'
            );
            return [];
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getStatesList();
    }, []);

    return (
        <div className="mt-3 envio-estado-modal">
            <div className="w-100">
                <div className="w-100 d-flex flex-column mb-3">
                    <h5 className="fw-bold text-uppercase">
                        {envio?.codigo_transporte}
                    </h5>
                    <h6 className="fw-bold text-uppercase">
                        {envio?.nombrePieza}
                    </h6>
                    <small>
                        Transportado por: &nbsp;
                        <span className="fw-bold text-uppercase">
                            {envio?.transportista_nombre}
                        </span>
                    </small>
                    <small>
                        Núm de seguimiento: &nbsp;
                        <span className="fw-bold">
                            {envio?.numero_seguimiento}
                        </span>
                    </small>
                </div>

                <CustomStepper
                    step={step}
                    envio={{ ...envio, estado: statesList }}
                />

                <div className="pt-4 pb-2">
                    <hr />

                    {envio?.transportista_id === 1 ? (
                        <>
                            {envio?.numero_seguimiento === '-' &&
                            !envio?.url_seguimiento ? (
                                <div className="w-100 d-flex align-items-center justify-content-between mt-2 p-2 border border-info border-1">
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        size="1x"
                                        className="action"
                                        color="#62B1F6"
                                    />
                                    <small className="mx-2 text-uppercase text-justify">
                                        Este envío lo gestiona el proveedor. si
                                        deseas solicitar la información de este
                                        envío, llámanos al{' '}
                                        <a href="tel:+34644175425">
                                            +34 644 175 425
                                        </a>
                                        , facilitando el número de envío:
                                        <span className="fw-bold ms-2">
                                            {envio.codigo_transporte}
                                        </span>
                                    </small>
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        size="1x"
                                        className="action"
                                        color="#62B1F6"
                                    />
                                </div>
                            ) : (
                                <div className="w-100 d-flex flex-column align-items-center justify-content-between mt-2 p-2 border border-info border-1">
                                    <small className="text-uppercase">
                                        Envío gestionado por el proveedor.
                                    </small>
                                    <small>
                                        Número de seguimiento: &nbsp;
                                        <span className="fw-bold">
                                            {envio?.numero_seguimiento}
                                        </span>
                                    </small>
                                    <small>
                                        <a
                                            href={envio?.url_seguimiento}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="link"
                                        >
                                            {envio?.url_seguimiento}
                                        </a>
                                    </small>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="w-100">
                                {
                                    <table className="w-100 table">
                                        <tbody>
                                            {isLoading
                                                ? Array(3)
                                                      .fill(null)
                                                      .map((_, i) => (
                                                          <tr key={i}>
                                                              <td className="text-center skeleton-row">
                                                                  <div className="skeleton skeleton--small center" />
                                                              </td>
                                                              <td className="text-center skeleton-row">
                                                                  <div className="skeleton skeleton--medium center" />
                                                              </td>
                                                          </tr>
                                                      ))
                                                : statesList
                                                      .map((estado, i) => {
                                                          return (
                                                              <tr key={i}>
                                                                  <td className="text-center">
                                                                      {
                                                                          estado?.nombre
                                                                      }
                                                                  </td>
                                                                  <td className="text-center">
                                                                      {moment(
                                                                          estado?.fecha
                                                                      ).format(
                                                                          'DD-MM-YYYY H:mm:ss'
                                                                      )}
                                                                  </td>
                                                              </tr>
                                                          );
                                                      })
                                                      .reverse()}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
